<div id="attach-company-popup" class="common-company-popup popup-sm">
    <form class="form" role="form" autocomplete="off" >
        <div class="popoup-hearder">
            <h2 class="m-b-5" mat-dialog-title>Adjuntar empresa</h2>
        </div>
        <div class="popoup-content">
            <div class="block-looper">
                <div class="form-wrap">
                    <mat-label aria-label="" class="label">Adjuntar empresa</mat-label>                  
                      <app-tree-view (companyNode)="onCompanySelcted($event)" class="tree-view" [origin]="1"></app-tree-view>
                </div>
            </div>
        </div>
        <div class="popoup-footer">
            <button class="keep" (click)="addCompany()"><span class="mat-button-wrapper">Guardar</span></button>
            <button class="cancel" (click)="cancel(false)"><span class="mat-button-wrapper">Cancelar</span></button>
        </div>
    </form>
</div>